module.exports = __webpack_public_path__ + "static/media/allplans.1a8d842f.png";